$(document).ready(function () {
  var selectedVariant = {};

  setDefaults();
  function applyDiscounts() {
    //// DISCOUNT CODE COOKIES ////////

    var codeCookieValue;
    var getCookie = function (name) {
      var value = "; " + document.cookie;
      var parts = value.split("; " + name + "=");
      if (parts.length == 2) return parts.pop().split(";").shift();
    };
    codeCookieValue = getCookie("discount_code");

    codeCookieValuecodeCookieValue = getCookie("discount_code");
    if (codeCookieValue) {
      if (codeCookieValue == "WELCOME20") {
        $(".additional20").removeClass("hidden");
      }
    }
  }
  function formatMoney(number, decPlaces, decSep, thouSep) {
    (decPlaces = isNaN((decPlaces = Math.abs(decPlaces))) ? 2 : decPlaces),
      (decSep = typeof decSep === "undefined" ? "." : decSep);
    thouSep = typeof thouSep === "undefined" ? "," : thouSep;
    var sign = number < 0 ? "-" : "";
    var i = String(
      parseInt((number = Math.abs(Number(number) || 0).toFixed(decPlaces)))
    );
    var j = i.length > 3 ? i.length % 3 : 0;

    return (
      sign +
      (j ? i.substr(0, j) + thouSep : "") +
      i.substr(j).replace(/(\decSep{3})(?=\decSep)/g, "$1" + thouSep) +
      (decPlaces
        ? decSep +
          Math.abs(number - i)
            .toFixed(decPlaces)
            .slice(2)
        : "")
    );
  }

  function setDefaults() {
    $(".continueButton").attr("href", "javascript:void(0)");
    $(".time-links").hide();
    updateCheckout();

    setTimeout(() => {
      $(".continueButton").attr("href", "javascript:void(0)");
    }, 300);
  }

  // Fix (INV-024 pillar 6): the previous version appended a SECOND
  // "?discount=" onto a returnURL that already had a query string (malformed
  // double-"?"), and hardcoded "&discount=FREESALMONSPREAD" over whatever
  // freebie the shopper actually had cookied — so every box checkout that
  // reached here carried the salmon-spread code regardless of the chosen
  // offer. This builds a single well-formed query string and passes through
  // the real discountCookie value (or omits the param entirely when there
  // isn't one). Top-level function (not inlined) so it's unit-testable via
  // source extraction, matching the pattern in seafood-plan-single-flow.js.
  //
  // PR B (ADR-0002 pt 4): freebie OFFER KEYS never ride the URL as a
  // discount param — the 6 unconditional FREE* codes are EXPIRED, and the
  // legit freebie is granted server-side by the automatic BXGY (no code
  // needed). Genuine live codes (WELCOME*, winback, affiliate) still pass
  // through. Key list kept inside the function so the source-extraction
  // tests capture it (mirrors FREEBIE_ITEMS_BY_CODE + the dropped-key
  // fallbacks in assets/DiscountManager.js).
  function buildBoxCheckoutURL(variantId, sellingPlanId, discountCookie) {
    var freebieOfferKeys = [
      "FREESMOKEDSALMON",
      "FREESCALLOPS",
      "FREEJERKY",
      "FREESALMONSPREAD",
      "FREEHALIBUT",
      "FREESALMONDIP",
      "FREEKING",
    ];

    var returnURL =
      "/cart/add?items[][id]=" +
      variantId +
      "&items[][quantity]=1&items[][selling_plan]=" +
      sellingPlanId +
      "&return_to=/checkout";

    if (discountCookie && freebieOfferKeys.indexOf(discountCookie) === -1) {
      var discountParams = new URLSearchParams({
        discount: discountCookie,
      });
      returnURL =
        returnURL +
        (returnURL.indexOf("?") === -1 ? "?" : "&") +
        discountParams.toString();
    }

    return returnURL;
  }

  function updateCheckout() {
    var delivery_weeks = 4;
    if (localStorage.getItem("box-weeks") !== null) {
      delivery_weeks = localStorage.getItem("box-weeks");
    }

    var selling_plan_id = "693379957010";

    switch (String(delivery_weeks)) {
      case "4":
        selling_plan_id = "693379957010";
        break;
      case "6":
        selling_plan_id = "693380022546";
        break;
      case "8":
        selling_plan_id = "693380088082";
        break;
    }

    localStorage.setItem("box-plan", selling_plan_id);

    var product_handle = "wild-caught-alaskan-salmon-box";

    switch (localStorage.getItem("box-food")) {
      case "whitefish":
        product_handle = "alaskan-whitefish-subscription-box";
        break;
      case "crab":
        product_handle = "alaskan-crab-variety-subscription-box";
        break;
      case "fishvariety":
        product_handle = "alaskan-fish-variety-subscription-box";
        break;
    }

    var ajaxUrl =
      window.Shopify.routes.root + "products/" + product_handle + ".js";

    $.ajax({
      url: ajaxUrl,
      type: "get",
      dataType: "json",
      success: function (product) {
        function addSamplePack(handle) {
          var product = {
            variant: null,
            image: null,
          };

          switch (handle) {
            case "alaskan-sockeye-salmon-subscription-box":
              product.title = "Salmon Sampler Box";
              product.variant = "50408581890322";
              product.image =
                "//nettotableseafoods.com/cdn/shop/files/variety-sample-square.jpg%3Fv=1729612412&width=1946";
              break;
            case "alaskan-fish-variety-subscription-box":
              product.title = "Variety Sampler Box";
              product.variant = "50408538145042";
              product.image =
                "//nettotableseafoods.com/cdn/shop/files/variety-sample-square.jpg%3Fv=1729612412&width=1946";
              break;
            case "alaskan-whitefish-subscription-box":
              product.title = "White Fish Sampler Box";
              product.variant = "50408581923090";
              product.image =
                "//nettotableseafoods.com/cdn/shop/files/variety-sample-square.jpg%3Fv=1729612412&width=1946";
              break;
          }

          if (product.image != null) {
            var returnURL =
              "/cart/add?items[][id]=" +
              product.variant +
              "&items[][quantity]=1";

            returnURL = "/cart/" + product.variant + ":1";

            return returnURL;
          }
        }

        if (product) {
          $("#product-customizer-cards").html("");

          var selling_plan_id = localStorage.getItem("box-plan");

          const skioSellingPlanGroups = product.selling_plan_groups.filter(
            (group) => group.app_id === "SKIO"
          );

          addSamplePack(product.handle);

          for (var i = 0; i < product.variants.length; i++) {
            var variant = product.variants[i];

            if (!variant.available) {
              continue;
            }

            var active_selling_plan = null;

            for (var j = 0; j < variant.selling_plan_allocations.length; j++) {
              var alloc = variant.selling_plan_allocations[j];
              const isSkio = skioSellingPlanGroups.some(
                (group) => group.id === alloc.selling_plan_group_id
              );

              if (String(alloc.selling_plan_id) == selling_plan_id && isSkio) {
                active_selling_plan = variant.selling_plan_allocations[j];
              }
            }

            if (!active_selling_plan) {
              continue;
            }

            var timeFrame = "Every " + delivery_weeks + " weeks";

            switch (delivery_weeks) {
              case "4":
                timeFrame = "Every month";
                break;
              case "8":
                timeFrame = "Every Other Month";
                break;
              case "16":
                timeFrame = "Every Two Months";
                break;
            }

            var totalWeight = 0;
            var meals = 0;
            var priceExtraText = "";
            // Fix #256 (companion): keep the preview discount LOCAL — never
            // write it back onto the allocation object. Here the product is
            // re-fetched per render so it didn't compound, but mutating shared
            // Shopify product data is the same trap that bit
            // seafood-plan-single-flow.js.
            var previewedPriceCents = active_selling_plan.price;
            var codeCookieValue = getCookie("discount_code");
            if (codeCookieValue) {
              const info = window.discountManager.discountCookieToInfoMap.get(codeCookieValue);
              if (info) {
                priceExtraText = info.priceDescriptor;
              }

              if (codeCookieValue == "WELCOME20") {
                // Flat $20 off at checkout, not 20% — see the matching comment
                // in seafood-plan-single-flow.js. Prices are in cents. Scoped
                // locally so this file can't collide with that file's
                // top-level const if both ever load on one page.
                const WELCOME20_FLAT_OFF_CENTS = 2000;
                previewedPriceCents = Math.max(
                  0,
                  previewedPriceCents - WELCOME20_FLAT_OFF_CENTS,
                );
              }
            }

            var priceNumber = previewedPriceCents / 100;

            // Fix #264: 2 decimals so the card matches the cart ($142.45, not $142).
            var priceFormatted = "$" + formatMoney(priceNumber, 2);
            var priceCompareString =
              variant.price != previewedPriceCents
                ? "$" + formatMoney(variant.price / 100, 2)
                : "";

            var savingsPercent =
              (active_selling_plan.compare_at_price -
                previewedPriceCents) /
              active_selling_plan.compare_at_price;
            var savingsString =
              savingsPercent > 0
                ? "SAVE " + parseInt(savingsPercent * 100) + "%"
                : null;

            if (
              variant.title.includes("4.5 lbs") &&
              !variant.title.includes("Only")
            ) {
              meals = 12;
              totalWeight = "4.5 lbs";
            } else if (variant.title.includes("9 lbs")) {
              meals = 24;
              totalWeight = "9 lbs";
            }

            if (meals > 0) {
              var discountCookie = getCookie("discount_code");
              var returnURL = buildBoxCheckoutURL(
                variant.id,
                selling_plan_id,
                discountCookie,
              );

              var checkoutURL = returnURL;
              var productURL = product.url;

              var packTitle = totalWeight + " " + product.title;

              $("#product-customizer-cards").loadTemplate(
                $("#template"),
                {
                  variantId: variant.id,
                  productName: product.title,
                  deliveryWeeks: delivery_weeks,
                  sellingPlan: selling_plan_id,
                  portions: meals,
                  packTitle: packTitle,
                  subText: "subtext",
                  timeFrame: timeFrame,
                  originalPrice: priceCompareString,
                  price: priceFormatted,
                  mainImage: product.featured_image,
                  savingsPercent: savingsString,
                  mainText: "mainText",
                  priceExtra: priceExtraText,
                  blueButtonCTA: "Select Box",
                  blueButtonURL: checkoutURL,
                  secondButtonCTA: "View More Details",
                  secondButtonURL: productURL,
                  productURL: productURL,
                  checkoutURL: checkoutURL,
                },
                { append: true, async: true }
              );


              $("#" + delivery_weeks + "weeks").addClass("active");

              $(".timeFrame").text(timeFrame);
            }
          }

          selectedVariant = localStorage.getItem("box-variant");
          if (
            selectedVariant !== null &&
            $("#" + selectedVariant).length != 0
          ) {
            $("#" + selectedVariant)
              .prop("checked", true)
              .trigger("click");
          } else {
            $("#product-customizer-cards .sub-select-card:first-child input")
              .prop("checked", true)
              .trigger("click");
          }
          applyDiscounts();
        }
      },
    });
  }

  $(window).on("unload", function () {
    $("#checkout-button span").show();
    $(".lds-ellipsis").remove();
    $("#checkout-button").prop("disabled", false);
  });

  $(document).on("click", ".changeTime", function () {
    $(".changeTime").hide();
    $(".time-links").show();
  });

  $(document).on("click", ".time-link", function () {
    var weeks = $(this).data("weeks");
    localStorage.setItem("box-weeks", weeks);
    $(".time-links").hide();
    $(".changeTime").show();
    updateCheckout();
  });

  $(document).on(" click", "input[name='boxsize']", function () {
    var variantId = $("input[name=boxsize]:checked").val();
    localStorage.setItem("box-variant", variantId);

    $(".continueButton").addClass("shake-action");
    setTimeout(function () {
      $(".continueButton").removeClass("shake-action");
    }, 1000);
  });

  $(document).on("click", ".continueButton", function () {
    $(this)
      .find("span")
      .after(
        '<div class="lds-ellipsis"><div></div><div></div><div></div><div></div></div>'
      );

    $(this).find("span").hide();
    $(this).prop("disabled", true);
    addToCart($(this));
  });

  // Restores the button to its pre-click state so a failed add leaves a live,
  // retryable control instead of a permanently spinning dead button.
  function resetContinueButton($button) {
    if (!$button || !$button.length) return;
    $button.find(".lds-ellipsis").remove();
    $button.find("span").show();
    $button.prop("disabled", false);
  }

  function addToCart($button) {
    var variantId = localStorage.getItem("box-variant");
    var sellingPlan = localStorage.getItem("box-plan");
    var items = [];

    items.push({
      quantity: 1,
      id: variantId,
      selling_plan: sellingPlan,
    });

    var cartUrl = "/checkout";

    // Routed through NttUtils.addItemsToCart rather than a raw $.ajax POST so this
    // add inherits CartAddGuard: /cart/add.js INCREMENTS, so an iOS in-app-webview
    // abort that drops the response — but not the add — must never be blind-retried
    // (INV-030 / ADR-0003). It also inherits the non-ok seam gate, so a 422 sold-out
    // can no longer resolve and redirect the shopper to /checkout without their box,
    // plus fetch_failed telemetry, which this path previously emitted none of.
    var nttUtils = window.NttUtils;

    if (!nttUtils || typeof nttUtils.addItemsToCart !== "function") {
      // NttUtils.js is script-tagged in layout/theme.liquid, so this is a deploy
      // gap, not a normal state. Fail loudly rather than falling back to the
      // unguarded POST this change exists to remove.
      console.error("box-size add aborted: NttUtils unavailable");
      resetContinueButton($button);
      return;
    }

    nttUtils
      .addItemsToCart(items, { step: "box-size-add-to-cart" })
      .then(function () {
        location.href = cartUrl;
      })
      .catch(function (error) {
        resetContinueButton($button);
        if (typeof nttUtils.showCartError === "function") {
          nttUtils.showCartError(
            "We couldn't add your box to the cart. Please try again.",
            {
              onRetry: function () {
                addToCart($button);
              },
            }
          );
        }
        console.error("box-size add failed", error);
      });
  }
});
